import { render, staticRenderFns } from "./ProgressBackwardItemAction.vue?vue&type=template&id=46d2056b&"
import script from "./ProgressBackwardItemAction.vue?vue&type=script&lang=js&"
export * from "./ProgressBackwardItemAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports